(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('grcControlCertificationFullController', Controller);

    Controller.$inject = ['$scope', '$state', 'commonAricService'];

    function Controller($scope, $state, commonAricService) {

        //Number of Validation Steps
        $scope.numSteps = $scope.boxContext.aricControls.length + $scope.boxContext.ownerAssessmentTypes.length;

        if ($scope.boxContext && $scope.boxContext.aricControls) {
            var controlIdx = _.findIndex($scope.boxContext.aricControls, { ControlID: $scope.boxModel.ControlID });
        }

        // Results
        $scope.results = [{
            model: 'IsControlDescriptionAccurate',
            askQuestion: true,
            templateUrl: require('./grcControlCertification.full.IsAccurate.tpl.html'),
            requiredModels: [{
                model: 'CertificationComment',
                requiredOn: [false]
            }]
        }, {
            model: 'ControlPerformance',
            askQuestion: true,
            templateUrl: require('./grcControlCertification.full.Performance.tpl.html'),
            requiredModels: [{
                model: 'CertificationComment',
                requiredOn: [2, 3] // Not Performant and Not Applicable
            }]
        }, {
            model: 'CertificationComment',
            templateUrl: require('./grcControlCertification.full.Comment.tpl.html'),
        }];

        // Required models based on results config
        $scope.requiredModels = [];

        // Answer Question
        $scope.answerQuestion = function (result, answer) {
            if (!$scope.canChangeCertification()) return;

            if ($scope.boxModel.ControlAssessment.IsCompleted) return;

            if (!_.isUndefined(answer)) {
                $scope.boxModel.ControlAssessment[result.model] = answer;
            }
            $scope.pageIsDirty();
            updateRequiredModels();
        };

        // Can Change Certification
        $scope.canChangeCertification = function () {
            if ($scope.readOnly) return false;

            return $scope.boxModel.ControlAssessment.IsCertifying;
        };

        // Show Save And Continue Action?
        $scope.showSaveAndContinueAction = function () {
            if ($scope.showSubmitAction()) return false;

            return isSavePossible();
        };

        // Show Save Action
        $scope.showSaveAction = function () {
            if (!$scope.showSubmitAction()) return false;

            return isSavePossible();
        };

        // Save And Continue
        $scope.saveAndContinue = function () {
            commonAricService
                .saveControlCertification($scope.boxModel)
                .then(function (savedAricControl) {
                    $scope.boxContext.aricControls[controlIdx] = savedAricControl;
                    $scope.pageIsNotDirty();

                    $scope.goToNextControl();
                });
        };

        // If ready for Certification Submission
        $scope.isCertificationReady = function () {
            var allControlsValidated = _.every($scope.boxContext.aricControls, {
                ControlAssessment: { IsCertificationInProgress: true }
            });

            return allControlsValidated && $scope.boxContext.controlOwnerAssessment.IsCertificationInProgress;
        };

        // Show Submit Action
        $scope.showSubmitAction = function () {
            if (!$scope.boxContext || !$scope.boxContext.aricControls) return;
            if ($scope.showResetAction()) return;

            return $scope.isCertificationReady();
        };

        // Submit
        $scope.submit = function () {
            if ($scope.ctxtCtrl.isSubmitting) return;

            $scope.ctxtCtrl.isSubmitting = true;
            commonAricService
                .submitControlCertification($scope.boxModel)
                .then(function () {
                    $state.go('aricCertification.user.completed');
                    $scope.pageIsNotDirty();
                })
                .finally(function () {
                    $scope.ctxtCtrl.isSubmitting = false;
                });
        };

        // Get CertifiedCount
        $scope.getCertifiedCount = function () {

            if (!$scope.boxContext || !$scope.boxContext.aricControls) return;

            var stepsValidated = _.filter($scope.boxContext.aricControls, { ControlAssessment: { IsCertificationInProgress: true } }).length;

            // To be improved to match real Owner Assemenet step numbers
            if ($scope.isCertificationReady()) {
                stepsValidated = stepsValidated + $scope.boxContext.ownerAssessmentTypes.length;
            }

            return stepsValidated;
        };

        // Show Reset Action?
        $scope.showResetAction = function () {
            return $scope.ctxtCtrl.needSaveChanges;
        };

        // Discard Changes
        $scope.discardChanges = function () {
            $state.reload();
        };

        // Show Previous Control Action
        $scope.showPreviousControlAction = function () {
            return (controlIdx > 0);
        };

        // Go To Previous Control
        $scope.goToPreviousControl = function () {
            if (!$scope.showPreviousControlAction()) return;

            var prevIdx = controlIdx - 1;
            $state.go('aricCertification.user.control', { ControlID: $scope.boxContext.aricControls[prevIdx].ControlID });
        };

        // Show Previous Control Action
        $scope.showNextControlAction = function () {
            return true;
        };

        // Go To Next Control
        $scope.goToNextControl = function () {

            if (!$scope.showNextControlAction()) return;

            var nextIdx = controlIdx + 1;

            if(nextIdx < $scope.boxContext.aricControls.length) {
                $state.go('aricCertification.user.control', {
                    ControlID: $scope.boxContext.aricControls[nextIdx].ControlID
                });
                return;
            }

            $state.go('aricCertification.user.assessment', { OwnerAssessmentType: $scope.boxContext.ownerAssessmentTypes[0] });
        };

        function updateRequiredModels() {
            $scope.requiredModels = [];
            _.each($scope.results, function (result) {
                if (!result.askQuestion || _.isUndefined(result.requiredModels)) return false;

                _.each(result.requiredModels, function (requiredModel) {
                    var requiredModelValue = $scope.boxModel.ControlAssessment[requiredModel.model];
                    if ((_.isUndefined(requiredModelValue) || requiredModelValue === "")
                        && _.indexOf(requiredModel.requiredOn, $scope.boxModel.ControlAssessment[result.model]) > -1) {
                        $scope.requiredModels.push(requiredModel.model);
                    }
                });
            });
        }

        function isSavePossible() {
            if (!$scope.ctxtCtrl.needSaveChanges) return false;

            var hasSomeQuestionsUnanswered =
                _.some($scope.results, function (result) {
                    if (!result.askQuestion) return false;

                    return _.isUndefined($scope.boxModel.ControlAssessment[result.model]);
                });

            if (hasSomeQuestionsUnanswered) return false;

            var hasSomeRequiredModelsEmpty =
                _.some($scope.requiredModels, function(reqModel) {
                    return _.isUndefined($scope.boxModel.ControlAssessment[reqModel]);
                });

            return  !hasSomeRequiredModelsEmpty;
        }

    }
})();
